import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Stack, Tooltip } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { IBasicModalProps } from '~/shared/types/types';

export const BasicModal: React.FC<IBasicModalProps> = ({
  tootlipText,
  open,
  handleOpen,
  handleClose,
  children,
  title_button,
  title_reset,
  reset,
  isIcon,
  disabled,
  buttonIcon,
  buttonVariant = 'contained',
  buttonSx,
  buttonLabelSx,
}) => {
  const resolvedIcon = buttonIcon || <AddBoxIcon />;

  return (
    <div style={{ flex: 1, display: 'flex', width: '100%' }}>
      <Stack flexDirection="row" gap={1} sx={{ width: '100%' }}>
        {title_reset && (
          <Button
            sx={{ flex: 1 }}
            variant="outlined"
            color="primary"
            onClick={() => reset && reset()}
            disabled={disabled}>
            {isIcon ? <AddBoxIcon /> : null}
            {title_reset}
          </Button>
        )}
        <Tooltip title={tootlipText}>
          <Box sx={{ width: '100%' }}>
            <Button
              sx={{
                flex: 1,
                minWidth: 0,
                ...buttonSx,
              }}
              fullWidth
              variant={buttonVariant}
              color="primary"
              onClick={handleOpen}
              disabled={disabled}
            >
              {isIcon && resolvedIcon}
              <Box
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flex: 1,
                  maxWidth: {
                    xs: 50,
                    lg: 150,
                  },
                  ml: isIcon ? 1 : 0,
                  ...buttonLabelSx,
                }}
              >
                {title_button}
              </Box>
            </Button>{' '}
          </Box>
        </Tooltip>
      </Stack>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: '12px',
          boxShadow: 24,
          p: 4,
          maxHeight: '90vh',
          overflowY: 'auto',
        }}>{children}</Box>
      </Modal>
    </div>
  );
};
